import { FormContactUs } from '@lib/domain/contact-us';
import { HTTPService } from '@lib/infra/HTTPService/HTTPService';

interface Dependencies {
    httpService: HTTPService;
}

export class ContactService {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }
    async sendContactEmail(payload: FormContactUs): Promise<boolean> {
        const { data } = await this.httpService.post({
            url: '/contact/',
            data: payload,
        });
        return data;
    }
}
